import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class DevToolsDetectService {
    private readonly devToolsOpen$ = new BehaviorSubject<boolean>(false);

    get devToolsStatus(): Observable<boolean> {
        return this.devToolsOpen$.asObservable();
    }

    constructor(private readonly ngZone: NgZone) {
        this.detectDevTools();
    }

    isDevToolsOpen(): boolean {
        return this.devToolsOpen$.getValue();
    }

    private detectDevTools(): void {
        this.ngZone.runOutsideAngular(() => {
            setInterval(() => {
                const threshold = 200;
                const widthThreshold = window.outerWidth - window.innerWidth > threshold;
                const heightThreshold = window.outerHeight - window.innerHeight > threshold;

                const isOpen = widthThreshold || heightThreshold;

                if (isOpen && !this.devToolsOpen$.value) {
                    this.devToolsOpen$.next(true);
                } else if (!isOpen && this.devToolsOpen$.value) {
                    this.devToolsOpen$.next(false);
                }
            }, 1000);
        });
    }
}
